import React, { useEffect, useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import './charge.css';
import cardpic from '@/assets/cardpic.svg';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { postSubscription } from '@/api/SubscriptionCustomer/postSubscription';
import storage from '@/utils/storage';
import { FeatureAd, addFeature } from '@/api/feature/addFeature';
import { useNotificationStore } from '@/stores/notifications';
import { payReeipo } from '@/api/doItByReeipo/payReeipo';
import { addSinglePayment, payAdminCommision, SinglePayment } from '@/api/feature/addSinglePayment';
import { lowerCase } from 'lodash';
import { formatPrice } from '@/utils/format';

const ChargeInvestCom = ({
  price,
  discount,
  propType,
  propId,
  formId,
  type,
}: {
  price: string;
  discount: number;
  propType: string;
  propId: string;
  formId: string;
  type: string;
}) => {
  const { addNotification } = useNotificationStore();
  const [searchParams] = useSearchParams();
  const invest_fund = searchParams.get('invest_com');
  const stripe = useStripe();
  const elements = useElements();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const previousData = storage.getSubmitFormData();
  const nextPage = previousData?.pageUrl;
  const currencyName = storage.getCurrencyName();
  const localCurrency = storage.getAmount();
  const lowerCurrency = lowerCase(currencyName);

  const { idSub } = useParams();
  const [subscriptionId, setsubscriptionId] = useState<number>(0);

  const percentageOff = (price: number, percentageValue: number): number => {
    return price * (1 - percentageValue / 100);
  };

  const netPrice = percentageOff(parseInt(price), discount);

  const finalAmount = netPrice.toString().split('.');

  useEffect(() => {
    if (idSub) {
      setsubscriptionId(parseInt(idSub));
    }
  }, [idSub]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    setIsLoading(true);

    const cardElement = elements.getElement(CardElement);

    if (!cardElement) {
      return;
    }

    try {
      // Create a token using a test card
      const { token } = await stripe.createToken(cardElement, {
        currency: lowerCurrency,
        name: 'Test User',
        address_line1: '123 Test Street',
        address_city: 'Test City',
        address_state: 'Test State',
        address_country: 'Test Country',
        address_zip: '12345',
      });

      if (token) {
        const cardToken = token?.id;
        if (propType !== 'null' && propId !== 'null') {
          if (type === 'doByReeipo') {
            const payload: SinglePayment = {
              property_type: propType,
              property_id: propId,
              payment_token: cardToken,
              price: formatPrice(price * localCurrency),
              currency: lowerCurrency,
            };
            const featureAd = await payAdminCommision(payload);
            addNotification({
              type: 'success',
              title: 'Succes',
              message: `Payment done successfully`,
            });
          } else {
            const payload: FeatureAd = {
              property_type: propType,
              property_id: propId,
              plan_id: idSub ?? '',
              payment_token: cardToken,
              price: formatPrice(price * localCurrency),
            };
            const featureAd = await addFeature(payload);
            addNotification({
              type: 'success',
              title: 'Succes',
              message: `Subscription purchased successfully`,
            });
          }
          navigate('/user/my-listing');
        } else if (discount?.toString() == 'null') {
          const data = {
            form_id: idSub,
            price: formatPrice(price * localCurrency),
            payment_token: cardToken,
          };
          const res = await payReeipo(data);
          if (res) {
            addNotification({
              type: 'success',
              title: 'Succes',
              message: `Payment completed successfully!`,
            });
          }
          navigate('/user/reeipo-deals');
          // navigate(`/user/reeipo-form/${idSub}`);
        } else {
          const data = await postSubscription(subscriptionId, cardToken, finalAmount[0]);
          {
            if (data) {
              {
                nextPage ? navigate(nextPage) : navigate('/user/subscription');
              }
            }
          }
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="payment-form mt-5">
      <div className="form-row">
        <img src={cardpic} alt="sd" className="img-fluid pymt-img" />
        <label htmlFor="card-element">Card Details</label>
        <CardElement
          id="card-element"
          options={{
            style: {
              base: {
                fontSize: '20px',
                fontFamily: 'Arial, sans-serif',
              },
            },
          }}
          className="card-details"
        />
        <button type="submit" disabled={!stripe || isLoading} className="pay-button mt-4">
          {isLoading ? 'Processing...' : 'Pay'}
        </button>
      </div>
    </form>
  );
};

export default ChargeInvestCom;
